
export function getRandomLetterA() {
    var randomIndex = Math.floor(Math.random() * 26); 
    var randomLetter = String.fromCharCode(65 + randomIndex); 
    return randomLetter;
  }
  
  export function getRandomLetterB() {
    var randomIndex = Math.floor(Math.random() * 26); 
    var randomLetter = String.fromCharCode(65 + randomIndex); 
    return randomLetter;
  }
  
  
  export function getRandomLetterC() {
    var randomIndex = Math.floor(Math.random() * 26); 
    var randomLetter = String.fromCharCode(65 + randomIndex); 
    return randomLetter;
  }
  
  
  export function getRandomLetterD() {
    var randomIndex = Math.floor(Math.random() * 26); 
    var randomLetter = String.fromCharCode(65 + randomIndex); 
    return randomLetter;
  }
  
  export function getRandomLetterE() {
    var randomIndex = Math.floor(Math.random() * 26); 
    var randomLetter = String.fromCharCode(65 + randomIndex); 
    return randomLetter;
  }
  
  export function getRandomLetterF() {
    var randomIndex = Math.floor(Math.random() * 26); 
    var randomLetter = String.fromCharCode(65 + randomIndex); 
    return randomLetter;
  }
  
  export function getRandomLetterG() {
    var randomIndex = Math.floor(Math.random() * 26); 
    var randomLetter = String.fromCharCode(65 + randomIndex); 
    return randomLetter;
  }
  
  export function getRandomLetterH() {
    var randomIndex = Math.floor(Math.random() * 26); 
    var randomLetter = String.fromCharCode(65 + randomIndex); 
    return randomLetter;
  }


// WEBPACK FOOTER //
// ./src/utils/max.js